import Constants from '../constants/GlobalConstants';

/**
 * ### dismiss notification popup
 */
export function dismissNotification (notification) {
  return { type: Constants.DISMISS_NOTIFICATION, data: notification };
}

/**
 * ### change active passenger
 */
export function changeActivePassenger (passenger) {
  return { type: Constants.CHANGE_ACTIVE_PASSENGER, data: passenger };
}

/**
 * ### change active step
 */
export function changeActiveStep (step) {
  return { type: Constants.CHANGE_ACTIVE_STEP, data: step };
}



// WEBPACK FOOTER //
// ./src/redux/actions/GlobalActions.js